"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case "GET_JSON_DATA_LIST_BY_CATEGORY": {
            payload.jsonDataByCategory.sort((n1, n2) => {
                if (n1.title > n2.title)
                    return 1;
                if (n1.title < n2.title)
                    return -1;
                return 0;
            });
            return Object.assign(Object.assign({}, state), { jsonDataByCategory: payload.jsonDataByCategory, jsonDataCategory: payload.jsonDataCategory });
        }
        case "GET_JSON_DATA_LIST_BY_ID_LIST": {
            return Object.assign(Object.assign({}, state), { jsonDataByIdList: payload });
        }
        case "REMOVE_CHART_DATA": {
            return Object.assign(Object.assign({}, state), { jsonDataByCategory: payload.jsonDataByCategory, jsonDataByIdList: payload.jsonDataByIdList, jsonDataCategory: payload.jsonDataByCategory });
        }
        default:
            return state;
    }
};
